export default function staticUrl() {
  let sUrl = null;
  const pathname = window.location.host.toLowerCase();
  const version = document.getElementById(`tcm_version`).value;
  if (pathname.indexOf(`thecoachingmanual.com`) > -1) {
    sUrl = `https://cdn.thecoachingmanual.com/app/${version}/`;
  } else if (pathname.indexOf(`beans.youballer.io`) > -1) {
    sUrl = `https://cdn.beans.youballer.io/app/${version}/`;
  } else {
    sUrl = `/`;
  }
  return sUrl;
}



// WEBPACK FOOTER //
// ./library/app/utils/staticPath.js